export default __webpack_public_path__ + "static/media/user.22c31152.png";